import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"

import { newsletter_card, header } from "./styles.module.scss"

import NewsletterSignup from "@components/forms/newsletter-signup"

const NEWSLETTER_VAL = {
  title: "Subscribe to the Amperity newsletter",
  description: "Customer data insights delivered straight to your inbox every month"
}

const NewsletterCard = ({
  className,
  title = NEWSLETTER_VAL.title,
  description = NEWSLETTER_VAL.description
}) => {
  const classes = classNames(className, newsletter_card)

  return (
    <div className={classes}>
      <p className={header}>{title}</p>
      <p>{description}</p>
      <NewsletterSignup theme="white-background" formId="2028" />
    </div>
  )
}

NewsletterCard.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string
}

export default NewsletterCard

NewsletterSignup.propTypes = {
  /**
   * Class name passed down from a parent
   */
  className: PropTypes.string,
  /**
   * The title or header of the card
   */
  title: PropTypes.string,
  /**
   * A short sentence describing the intended action
   */
  description: PropTypes.string
}
